import React from 'react';

/**
 * PageHeader
 * ------------------------------------------------------------------
 * Top greeting row of the dashboard: title + subtitle on the left,
 * action buttons slot on the right. Generic enough to reuse on any
 * page that needs a heading + actions row.
 *
 * @param {string} title - e.g. "Good Morning, Alex"
 * @param {string} subtitle
 * @param {React.ReactNode} actions - e.g. <Button/> <Button/>
 */
const PageHeader = ({ title, subtitle, titleAddon, actions, className = '' }) => (
  <div className={`page-header ${className}`}>
    <div className="page-header__text">
      <div className="page-header__title-row">
        <h1 className="page-header__title">{title}</h1>
        {titleAddon}
      </div>
      {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
    </div>
    {actions && <div className="page-header__actions">{actions}</div>}
  </div>
);

export default PageHeader;
